{
  "welcome": "Welcome to AirPlx {{email}}!",
  "errorTitle": "We weren't able to log you in.",
  "errorMessage": "Click the button below to try again. If this issue persists, please contact support@airplx.com."
}
